<template>
  <div class="wia-container">
    <div class="wia-box">
      <h2 class="wia-title">{{ config.i18n.wia_seo_l1_issue }}</h2>
      <div class="wia-categories">
        <a class="wia-category" :href="allLink + '--l1-issue?cat='+categorySelected + '&name='+categoryNameSelected + '&l1=' + issue.id" v-for="issue in issueOptions" v-bind:key="issue.id">
          {{ issue.description }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'WIA-SeoL1Issue',
  title: 'WIA Category Selection',
  description: 'WIA Category Selection',
  meta: {
    name: 'robots',
    content: 'noindex'
  },
  data () {
    return {
      categorySelected: '',
      categoryNameSelected: '',
      issueOptions: [
      ],
      allLink: ''
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    config: function () {
      return this.$store.state.config
    },
    detail: function () {
      return this.$store.state.details
    }
  },
  methods: {
    getQueryStringValue (key) {
      // eslint-disable-next-line
      return decodeURIComponent(window.location.href.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"))
    }
  },
  mounted () {
    this.allLink = document.location.pathname.replace(/\/$/, '')
    this.allLink = this.allLink.replace('/--category-issue', '/')
    this.categorySelected = this.getQueryStringValue('cat')
    this.categoryNameSelected = this.getQueryStringValue('name')
    // /macro_categories/{language}
    this.$http.get(this.$store.state.config.endpoint + '/macro_categories/' + this.$store.state.config.language.toLowerCase()).then(
      result => {
        this.issueOptions = result.body
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../../style/main';

.brand-theme-id {
}

.wia-categories {
  max-width: 68rem;
  margin: 0 auto;
}

.wia-category {
  display: block;
  width: 100%;
  text-decoration: underline;
  margin-bottom: 5px;
}

.brand-theme-hp {
}

.brand-theme-bk {
}

.brand-theme-wp {
}

.brand-theme-mb {
}

</style>
